var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"monitoring__content"},[(!!_vm.analysis)?_c('monitoring-viewer',{attrs:{"uuid":_vm.uuid,"source":_vm.source}}):_c('agro-interative-loading')],1)}
var staticRenderFns = []

export { render, staticRenderFns }